import app from "../_app";

const productPopup = document.querySelector('.js-product-popup');

export const openProductPopupHandler = (popup) => {
    if(productPopup) {

        if(!document.querySelector('body').classList.contains('locked')) {
            app.lockBody();
        }

        productPopup.setAttribute('data-open', '');
        productPopup.classList.add(popup.dataset.popupPosition);
        productPopup.querySelector('.js-product-popup-content').querySelector('.'+CSS.escape(popup.dataset.popupContent)).classList.toggle('d-block');
    }
};

if(productPopup) {
    const closeTriggers = [...productPopup.querySelectorAll('.js-product-popup-close')];

    const closeProductPopupHandler = () => {
        productPopup.removeAttribute('data-open');
        [...productPopup.querySelector('.js-product-popup-content').querySelectorAll('div')].map(element => {
            setTimeout(() => {
                element.classList.remove('d-block');
            }, 500);
        });
        app.unlockBody();
    };

    closeTriggers.map(closeTrigger => closeTrigger.addEventListener('click', closeProductPopupHandler));
}
